module.exports = __webpack_public_path__ + "media/customizations/default/chat-bubble 2-c9e003ad774ada27abf071eb0b3ad179.png";